module.exports = __webpack_public_path__ + "img/40_BF18_gone_to_seed.645d9b26.jpg";